import React, { createContext } from 'react';

export const ModalDispatchContext = createContext({
  open: (Component: () => React.ReactElement, props: ModalProps) => {},
  close: (Component: () => React.ReactElement) => {},
  reset: () => {},
});

export const ModalsStateContext = createContext<Modal[]>([]);
